import Axios from "axios";
import appUrl from "../../config/appUrl";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const DashboardReducer = createSlice({
  name: "dashboard",
  initialState: {
    data: [],
  },
  reducers: {
    resetChangeStatus(state, action) {
      return { ...state, changeSuccess: undefined };
    },
    setSelectedMonth(state, action) {
      return { ...state, selectedMonth: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardList.pending, (state, action) => {
        return { ...state, loading: true };
      })
      .addCase(getDashboardList.fulfilled, (state, action) => {
        return { ...state, loading: false, data: action.payload };
        // return { ...state, loading: false, data: action.payload, selectedMonth: `${new Date().getFullYear()}-${(new Date().getMonth().toString()).length === 1 ? '0' + (new Date().getMonth() + 1).toString() : new Date().getMonth()}`,byMonthLoading:false }
      })
      .addCase(getDashboardList.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(getDashboardStats.pending, (state, action) => {
        return { ...state, statsLoading: true };
      })
      .addCase(getDashboardStats.fulfilled, (state, action) => {
        return { ...state, statsLoading: false, stats: action.payload };
      })
      .addCase(getDashboardStats.rejected, (state, action) => {
        return {
          ...state,
          statsLoading: false,
          statsError: action.payload,
        };
      });
  },
});

export default DashboardReducer.reducer;
export const { resetChangeStatus, setSelectedMonth } = DashboardReducer.actions;

// Thunks
// department Get Thunk
export const getDashboardList = createAsyncThunk(
  "dashboard/fetch",
  async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await Axios.get(appUrl.baseUrl + appUrl.getList);

      return fulfillWithValue(data);
    } catch (error) {
      throw rejectWithValue(
        error.response && error.response.data.msg
          ? error.response.data.msg
          : error.message
      );
    }
  }
);

export const getDashboardStats = createAsyncThunk(
  "dashboardStats/get",
  async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await Axios.get(appUrl.baseUrl + appUrl.getStats);

      return fulfillWithValue(data);
    } catch (error) {
      // console.log(error);

      throw rejectWithValue(
        error.response && error.response.data.msg
          ? error.response.data.msg
          : error.message
      );
    }
  }
);

// [
//     {
//         "_id": "63ee2c4d0084f72831da7f37",
//         "QR": {
//             "_id": "63edc077ea2e1d5ff529f98a",
//             "qrId": "c6c0a710-13bd-4121-af82-8f868b3bfdd3",
//             "createdAt": "2023-02-16T05:34:47.490Z",
//             "updatedAt": "2023-02-16T05:34:47.490Z",
//             "__v": 0
//         },
//         "vehicleRegNumber": "ISB-3214",
//         "checkIn": true,
//         "checkout": false,
//         "createdAt": "2023-02-16T13:14:53.943Z",
//         "updatedAt": "2023-02-16T13:14:53.943Z"
//     }
// ]
